// React
import { useContext } from "react"

// Components
import { CreatePage } from "pages/Card/Transaction/CreateNewCustomer/components"

// Contexts
import { IframeContext } from "contexts"

export function CreateNewCustomer(): JSX.Element {
  // Hooks
  const { onClose } = useContext(IframeContext)

  return (
    <CreatePage
      asModal
      onSuccess={onClose}
    />
  )
}